import { useScopeParams } from "@/hooks/useScopeParams";
import { PageTemplate } from "@/components/Templates/PageTemplate";

export default function ConcomitantProcedures({
  singleSubjectId,
}: {
  singleSubjectId?: string;
}) {
  const { id } = useScopeParams();

  return (
    <PageTemplate
      title="Safety: Concomitant Procedures"
      tooltipText="Explore concomitant procedure records, create data subsets, and download data."
      type="concomitant_procedures"
      constants={{
        wikiLink: "/wiki/guides/exploration-safety-concomitant-procedures",
        idLink: (subjectId: string) =>
          `/${id}/subjects/overview/${subjectId}/concomitant-procedures`,
      }}
      subjectId={singleSubjectId}
    />
  );
}
